"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../mixins/siteText"));
const sitetext_1 = require("../filters/sitetext");
exports.default = vue_1.default.extend({
    name: 'progress-bar',
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        showProgressBar() {
            return this.currentWorkflowMaxSteps > 0;
        },
        currentWorkflowMaxSteps() {
            return this.$store.getters.currentWorkflowMaxSteps;
        },
        currentWorkflowStep() {
            return this.$store.getters.currentWorkflowStep;
        },
        percentComplete() {
            const currentCompletion = this.currentWorkflowStep * 100 / this.currentWorkflowMaxSteps;
            return currentCompletion > 100 ? 100 : currentCompletion;
        },
        progressBarHeading() {
            return this.getSiteText('Forgot.Progressbar.Heading', this.currentWorkflowStep, this.currentWorkflowMaxSteps);
        },
    },
});
